import React from 'react';
import { gql, useQuery, useMutation } from '@apollo/client';
import { formatDateTime } from '../utils/helpers';
import './Devices.css';

const GET_DEVICES = gql`
  query { devices { id name type lat lng status lastSeen configJson } }
`;
const UPDATE_DEVICE = gql`
  mutation UpdateDevice($id: ID!, $status: String) {
    updateDevice(id: $id, status: $status) { id status }
  }
`;

const typeIcon: Record<string, string> = { MASTER: '🖥️', RF_SENSOR: '📡', CAMERA: '📷', WIDEBAND: '📻' };

export default function Devices() {
  const { data, loading, refetch } = useQuery(GET_DEVICES, { pollInterval: 10000 });
  const [updateDevice] = useMutation(UPDATE_DEVICE);

  const handleToggle = async (id: string, status: string) => {
    await updateDevice({ variables: { id, status: status === 'online' ? 'offline' : 'online' } });
    refetch();
  };

  return (
    <div className="page-container">
      <div className="page-header"><h2>📡 Devices</h2></div>
      {loading ? <div className="loading">Loading...</div> : (
        <div className="devices-grid">
          {(data?.devices || []).map((d: any) => (
            <div key={d.id} className={`device-card ${d.status}`}>
              <div className="device-header">
                <span className="device-type-icon">{typeIcon[d.type] || '📦'}</span>
                <div>
                  <div className="device-name">{d.name}</div>
                  <div className="device-type">{d.type}</div>
                </div>
                <span className={`status-badge ${d.status}`}>{d.status}</span>
              </div>
              <div className="device-details">
                {d.lat && <div className="device-detail">📍 {d.lat.toFixed(4)}, {d.lng?.toFixed(4)}</div>}
                <div className="device-detail">🕐 Last seen: {formatDateTime(d.lastSeen) || 'Never'}</div>
                <div className="device-detail"><code className="id-code">{d.id}</code></div>
              </div>
              <button className="btn-secondary btn-sm" onClick={() => handleToggle(d.id, d.status)}>
                {d.status === 'online' ? '⏹ Set Offline' : '▶ Set Online'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
